import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';
import {isObservable, Observable, Subscription} from "rxjs";

@Component({
  selector: 'app-chip',
  styles: [
    `._fieldset {
      border: 1px solid gray;
      padding: 4px 12px;
      border-radius: 10px;
      margin-bottom: 19px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    `
  ],
  template: `
    <fieldset [formGroup]='group' class="_fieldset">
      <mat-label class="me-3">{{ field?.label }}</mat-label>
      <mat-chip-listbox [attr.aria-label]="field?.label" [formControlName]="field.key">
        <mat-chip-option *ngFor="let item of options"
                         [value]="item?.value">{{ item?.name }}
        </mat-chip-option>
      </mat-chip-listbox>
    </fieldset>
  `,
})
export class ChipComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  options: any[] = [];
  sub = new Subscription();

  constructor() {
  }

  ngOnInit() {
    if (this.field?.options) this.setItems(this.field.options);
  }

  async setItems(options: any[] | Observable<any[]>) {
    if (isObservable(options)) this.sub.add(options?.subscribe(x => this.setItems(x)));
    else this.options = this.getModifiedOptions(options);
    this.field.options = this.options;
  }

  getModifiedOptions(options = []) {
    const x = this.field;
    if (x?.mapFunction) options = options.map(i => x.mapFunction(i));

    const s = x?.sortField ?? 'name';
    const isDESC = x?.sortDirection === 'DESC';
    const compare = (a, b) =>
      isDESC ? b?.[s].localeCompare(a?.[s]) : a?.[s]?.localeCompare(b?.[s]);

    if (options?.[0]?.hasOwnProperty(s)) options = options.sort((a, b) => compare(a, b));
    return options;
  }


}
